/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

 import React, { Component } from 'react';
 import './styles/css/thanks.css';
 import { Button, Header, Segment, Image} from 'semantic-ui-react';
 import { Input, FreeForm, FormRow } from 'kx-common-components';
 import Ship from '../media/ship.png';
 import Hero from '../media/rs-backgrounds/hero-vector.svg'
 
 class Thanks extends Component {
     render () {
         return (

            <Segment padded='very' className="signup-container">
    
            <div className='login-form'>
                <Header id ='thanks-largest' as='h1'>Thanks for the information!</Header>
                {/* <Image src={Ship}/> */}
                <center>
                    <p id='thanks-smaller'>We will send you an email shortly to setup your account and onboard with our application. </p>
                </center>
            </div>
    
            {/* <Form>
              <Form.Field>
                <Form.Input
                  placeholder='My Company'
                  label='COMPANY NAME'
                  name="companyName"
                  value={companyName}
                  className="signup-input"
                  error={this.state.error}
                  onChange={this.handleChange}
                />
                <Form.Input
                  placeholder='John Doe'
                  label='CONTACT NAME'
                  name="contactName"
                  value={contactName}
                  className="signup-input"
                  error={this.state.error}
                  onChange={this.handleChange}
                />
                <Form.Input
                  placeholder='john.doe@mycompany.com'
                  label='EMAIL'
                  name="email"
                  value={email}
                  type="email"
                  className="signup-input"
                  error={this.state.error}
                  onChange={this.handleChange}
                />
              </Form.Field>
              <center>
              <Button
                type='submit'
                className="signupButton"
                color="twitter"
                disabled={!this.state.email}
                onClick={this.handleSubmit}
              >SIGN UP</Button>
                <br /> <br />
                Already a member? <Link to='/' className="forgotLogin" >  Log in</Link>
              </center>
    
              <br />
              <div id='loginError'></div>
    
            </Form> */}
          </Segment>


            // <Segment basic>
            // <center>
            //     <Header id ='thanks-largest' as='h1'>Thanks for the information!</Header>
            //     <Image src={Hero}/>
            // </center>

            // <br /> <br />

            // <p id='thanks-smaller'>Thanks for signing up. We will send you an email shortly to setup your account and onboard with our application. </p>

            // <p id='thanks-smallest'>Please check your email inbox and make sure our email isn't in your Junk folder.</p>

            // </Segment>
         )
     }
 }

 export default Thanks;